module.exports = __webpack_public_path__ + "img/shouji.34612c5e.png";